import {
  Bug, Rat, Bug as BugIcon, Shield, SprayCan, Home, Building2, Leaf,
  Zap, Bird, CalendarClock, Layers,
} from "lucide-react";

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_pest-control-pro-38/artifacts/nogsqtu9_logo.webp";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1670989292166-8b20b9530438?crop=entropy&cs=srgb&fm=jpg&q=85",
  home: "https://images.unsplash.com/photo-1777428762767-e3a797da389a?crop=entropy&cs=srgb&fm=jpg&q=85",
  pest: "https://images.unsplash.com/photo-1759379077720-b099c6cf2f71?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const CONTACT = {
  phone: "+1 (672) 377-5455",
  phoneRaw: "16723775455",
  phoneAlt: "+1 (604) 723-5472",
  phoneAltRaw: "16047235472",
  email: "Exora.pestcontrol@gmail.com",
  hours: "Mon–Fri: 9:00 AM – 5:00 PM · Sat–Sun: Emergency only",
  address: "Surrey, British Columbia, Canada",
};

export const SERVICES = [
  { slug: "ant-control", name: "Ant Control", icon: Bug,
    desc: "Targeted treatment that eliminates colonies at the source, not just the trail.",
    signs: ["Trails along baseboards", "Kitchen swarms", "Small dirt mounds"],
    process: ["Colony inspection & species ID", "Non-repellent barrier application", "Bait station placement", "30-day follow-up"] },
  { slug: "bed-bug-treatment", name: "Bed Bug Treatment", icon: BugIcon,
    desc: "Heat and residual treatments that eradicate bed bugs at every life stage.",
    signs: ["Bites in a line", "Rusty spots on sheets", "Sweet musty odor"],
    process: ["Canine/visual detection", "Heat remediation", "Residual treatment", "Re-inspection"] },
  { slug: "cockroach-control", name: "Cockroach Control", icon: Bug,
    desc: "Gel baiting and IGR programs that break the breeding cycle for good.",
    signs: ["Droppings near appliances", "Egg casings", "Musty smell"],
    process: ["Harborage mapping", "Gel bait + IGR", "Sanitation guidance", "Monitoring"] },
  { slug: "rodent-control", name: "Rodent Control", icon: Rat,
    desc: "Exclusion-first rodent management that seals entry points permanently.",
    signs: ["Gnaw marks", "Droppings", "Scratching in walls"],
    process: ["Entry point audit", "Exclusion sealing", "Trapping program", "Sanitize & verify"] },
  { slug: "spider-removal", name: "Spider Removal", icon: BugIcon,
    desc: "Web removal and perimeter treatment that keeps spiders outside where they belong.",
    signs: ["Webs in corners", "Egg sacs", "Frequent sightings"],
    process: ["Perimeter inspection", "De-webbing", "Barrier spray", "Prevention plan"] },
  { slug: "wasp-hornet-removal", name: "Wasp & Hornet Nest Removal", icon: Zap,
    desc: "Safe, same-day nest removal by licensed technicians in protective gear.",
    signs: ["Visible nests", "Increased activity", "Buzzing in walls"],
    process: ["Nest location", "Protective removal", "Void treatment", "Deterrent application"] },
  { slug: "termite-inspection", name: "Termite Inspection", icon: Shield,
    desc: "Comprehensive termite inspections and Sentricon baiting to protect your investment.",
    signs: ["Mud tubes", "Hollow wood", "Discarded wings"],
    process: ["Full structure inspection", "Moisture reading", "Baiting/liquid barrier", "Annual monitoring"] },
  { slug: "mosquito-control", name: "Mosquito Control", icon: SprayCan,
    desc: "Seasonal fogging and larvicide programs that reclaim your outdoor spaces.",
    signs: ["Standing water breeding", "Dusk swarms", "Frequent bites"],
    process: ["Habitat survey", "Larvicide treatment", "Barrier fogging", "Monthly service"] },
  { slug: "wildlife-removal", name: "Wildlife Removal", icon: Bird,
    desc: "Humane trapping and relocation of raccoons, squirrels, bats and more.",
    signs: ["Attic noises", "Damaged vents", "Nesting debris"],
    process: ["Humane assessment", "Live trapping", "Exclusion & repair", "Decontamination"] },
  { slug: "commercial-pest-management", name: "Commercial Pest Management", icon: Building2,
    desc: "Audit-ready IPM programs for restaurants, warehouses, offices and retail.",
    signs: ["Compliance requirements", "Recurring activity", "Sensitive inventory"],
    process: ["Facility risk audit", "Custom IPM plan", "Scheduled service", "Digital documentation"] },
  { slug: "residential-pest-control", name: "Residential Pest Control", icon: Home,
    desc: "All-in-one home protection covering the most common household pests year-round.",
    signs: ["Multiple pest types", "Seasonal invasions", "Peace of mind"],
    process: ["Home assessment", "Interior + exterior treatment", "Entry sealing", "Quarterly visits"] },
  { slug: "preventative-maintenance", name: "Preventative Maintenance Plans", icon: CalendarClock,
    desc: "Recurring, eco-conscious plans that stop pests before they ever get in.",
    signs: ["Want year-round coverage", "Recently treated", "New property"],
    process: ["Baseline treatment", "Scheduled visits", "Free re-treats", "Priority booking"] },
];

export const WHY_CHOOSE = [
  { icon: Shield, title: "Licensed & Insured", desc: "Fully certified technicians backed by comprehensive insurance and state licensing." },
  { icon: Leaf, title: "Eco-Conscious", desc: "Family- and pet-safe treatments that protect your home and the environment." },
  { icon: Zap, title: "Same-Day Emergency", desc: "Urgent infestations handled fast with our 24/7 emergency response team." },
  { icon: Layers, title: "Guaranteed Results", desc: "If pests return between visits, so do we — free of charge. Guaranteed." },
];

export const PROPERTY_TYPES = ["House", "Apartment", "Condo", "Office", "Restaurant", "Warehouse", "Retail", "Other"];
export const PEST_TYPES = ["Ants", "Mice", "Rats", "Cockroaches", "Bed Bugs", "Wasps", "Bees", "Spiders", "Fleas", "Mosquitoes", "Termites", "Wildlife", "Unknown"];
export const SEVERITIES = ["Low", "Medium", "High", "Emergency"];
export const TIME_SLOTS = ["Morning (8am–12pm)", "Afternoon (12pm–4pm)", "Evening (4pm–8pm)", "Anytime"];

export const REVIEWS = [
  { name: "Amanda Foster", city: "Surrey, BC", rating: 5, photo: "https://i.pravatar.cc/150?img=47",
    text: "EXORA cleared a serious ant problem in one visit. The technician was professional, eco-friendly, and explained everything. Haven't seen a single ant since." },
  { name: "Marcus Lee", city: "Langley, BC", rating: 5, photo: "https://i.pravatar.cc/150?img=12",
    text: "We had a bed bug scare at our rental units. Their heat treatment was thorough and the follow-up gave us total peace of mind. Highly recommend." },
  { name: "Priya Patel", city: "Burnaby, BC", rating: 5, photo: "https://i.pravatar.cc/150?img=32",
    text: "The online inspection request was so easy — I uploaded photos and got a call within the hour. Termite baiting done and monitored. Five stars." },
  { name: "Derek Johnson", city: "Vancouver, BC", rating: 5, photo: "https://i.pravatar.cc/150?img=15",
    text: "Best commercial pest partner our restaurant has had. Audit-ready documentation and zero activity for months. Their team is fantastic." },
  { name: "Sophie Nguyen", city: "Delta, BC", rating: 5, photo: "https://i.pravatar.cc/150?img=45",
    text: "Humane wildlife removal for a raccoon in our attic. They sealed everything and cleaned up. Kind, fast, and honest pricing." },
  { name: "Tom Bradley", city: "Coquitlam, BC", rating: 5, photo: "https://i.pravatar.cc/150?img=51",
    text: "Signed up for the preventative plan and it's the best decision. Quarterly visits, free re-treats, and truly pest-free all year." },
];

export const SERVICE_AREAS = [
  { region: "Surrey & White Rock", cities: ["Surrey", "White Rock", "Cloverdale", "South Surrey"] },
  { region: "Fraser Valley", cities: ["Langley", "Abbotsford", "Maple Ridge", "Mission"] },
  { region: "Tri-Cities & Burnaby", cities: ["Burnaby", "Coquitlam", "Port Coquitlam", "New Westminster"] },
  { region: "Vancouver & North Shore", cities: ["Vancouver", "Richmond", "Delta", "North Vancouver"] },
];

export const FAQS = [
  { q: "Are your treatments safe for children and pets?", a: "Yes. We use eco-conscious, EPA-approved products applied by licensed technicians. We'll advise on any short re-entry times where needed." },
  { q: "How quickly can you come out?", a: "Standard inspections are usually scheduled within 24–48 hours. Emergency infestations get same-day priority — call +1 (672) 377-5455." },
  { q: "Do you offer a guarantee?", a: "Absolutely. If covered pests return between scheduled visits, we re-treat at no additional charge." },
  { q: "What areas do you serve?", a: "We serve Surrey and the greater Metro Vancouver area including Langley, Burnaby, Coquitlam, Delta, Vancouver, Richmond and surrounding communities." },
  { q: "Is a free inspection really free?", a: "Yes — your initial inspection and quote are 100% free with no obligation to book service." },
  { q: "Do you offer financing?", a: "For larger termite and wildlife exclusion jobs we offer flexible monthly payment plans. Ask your technician for details." },
];

export const PEST_GUIDE = [
  { name: "Carpenter Ants", danger: "Structural", tip: "Large black ants near wood; can weaken structures over time.", season: "Spring–Summer" },
  { name: "Norway Rats", danger: "Health", tip: "Gnaw wires and contaminate food; seal gaps larger than 1/4 inch.", season: "Fall–Winter" },
  { name: "German Cockroaches", danger: "Health", tip: "Rapid breeders in kitchens; sanitation is key to control.", season: "Year-round" },
  { name: "Subterranean Termites", danger: "Structural", tip: "Build mud tubes; cause billions in damage annually.", season: "Spring" },
  { name: "Black Widow Spiders", danger: "Venomous", tip: "Prefer dark undisturbed areas; wear gloves in garages.", season: "Summer–Fall" },
  { name: "Paper Wasps", danger: "Sting", tip: "Umbrella nests under eaves; never remove active nests yourself.", season: "Summer" },
];

export const SEASONAL_TIPS = [
  { season: "Spring", color: "#38A169", tips: ["Seal foundation cracks", "Clear standing water", "Watch for termite swarmers"] },
  { season: "Summer", color: "#D4AF37", tips: ["Fog for mosquitoes", "Remove wasp nests early", "Store food airtight"] },
  { season: "Fall", color: "#C05621", tips: ["Block rodent entry points", "Trim vegetation off siding", "Inspect firewood"] },
  { season: "Winter", color: "#2B6CB0", tips: ["Check attic for wildlife", "Reduce indoor moisture", "Schedule prevention visit"] },
];

export const BLOG_POSTS = [
  { slug: "spring-pest-prevention", title: "5 Spring Pest Prevention Tips Every Homeowner Should Know", excerpt: "As temperatures rise, pests wake up. Here's how to stay ahead of the season.", date: "Mar 12, 2026", tag: "Prevention", img: IMAGES.home },
  { slug: "signs-of-termites", title: "The Silent Threat: 7 Warning Signs of a Termite Infestation", excerpt: "Termites cause billions in damage each year. Learn the signs before it's too late.", date: "Feb 28, 2026", tag: "Termites", img: IMAGES.pest },
  { slug: "eco-friendly-pest-control", title: "Why Eco-Conscious Pest Control Is Better for Your Family", excerpt: "Effective doesn't mean harsh. How modern IPM protects your home and the planet.", date: "Feb 10, 2026", tag: "Eco", img: IMAGES.hero },
];
